import React, { useEffect, useState } from "react";

import URL from "../../../config/api";
import getStudentsData from "../DataFromBackend/StudentsData";
import GradeTablesMajorMinor from "../GradeTablesMajorMinor";

import "./styles.scss";

const ListaNotas = ({ applications, onShowCorrectQuestionList }) => {
  const [studentsList, setStudentsList] = useState(null);

  useEffect(() => {
    const studentsData = getStudentsData(applications);
    setStudentsList(studentsData);
  }, [applications]);

  return (
    <>
      <div className="" style={{ marginBottom: "40px" }}>
        <table className="table table-hover table-outline mb-0 d-none d-sm-table listanotas">
          <thead className="thead-light">
            <tr>
              <th>Nº</th>
              <th>Estudante</th>
              <th>Nota</th>
            </tr>
          </thead>
          <tbody>
            {studentsList &&
              studentsList.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => {
                    onShowCorrectQuestionList();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <td>{index + 1}</td>
                  {/* <td className="text-center">  */}
                  <td>
                    <div className="d-flex align-items-center">
                      <div className="c-avatar mr-3">
                        <img
                          src={
                            URL.img +
                            (item.foto || "uploads/users/profileEmpty.jpg")
                          }
                          className="c-avatar-img"
                          alt="imagem"
                        />
                      </div>
                      {item.nome}
                    </div>
                  </td>
                  <td>{item.nota}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {studentsList && <GradeTablesMajorMinor studentsData={studentsList} />}
    </>
  );
};

export default ListaNotas;
